// extracted by mini-css-extract-plugin
module.exports = {"container":"_1OraBP0H2BuffjpDBmH-Gh","icon":"_1Wif2woY9euBMJy0TO73wW"};